module.exports = __webpack_public_path__ + "media/images/emblems/Buerglen(Turgovio)-Blazono-72f0d1968d030e82b6ad61916f8406eb.png";